import React, {useState, useEffect} from "react"
import {makeStyles} from "tss-react/mui"
import InputLabel from "@mui/material/InputLabel"
import MenuItem from "@mui/material/MenuItem"
import FormHelperText from "@mui/material/FormHelperText"
import FormControl from "@mui/material/FormControl"
import Select from "@mui/material/Select"
import {SelectChangeEvent} from "@mui/material"

const useStyles = makeStyles()((theme) => ({
	formControl: {
		margin: theme.spacing(1),
		minWidth: 300,
	},
}))

interface DropdownProps {
	label: string
	helperText: string
	values: string[]
	update: (field: string) => void
	minWidth?: number
	disabled?: boolean
	currentValue?: string
}

export default function Dropdown(props: DropdownProps) {
	const {classes} = useStyles()
	const [field, setField] = useState<string>("")
	const disabled = props.disabled === true

	useEffect(() => {
		setField("")
	}, [])

	const localUpdate = async (val: string) => {
		props.update(val)
	}

	const handleChange = async (event: SelectChangeEvent<string>) => {
		await localUpdate(event.target.value as string)
		setField(event.target.value as string)
	}

	return (
		<FormControl
			className={classes.formControl}
			style={{minWidth: props.minWidth ? props.minWidth : 300}}
			variant="standard"
		>
			<InputLabel id="dropdown-input-helper-label" style={{backgroundColor: "white"}}>
				{props.label}
			</InputLabel>
			<Select
				labelId="dropdown-select-helper-label"
				id="dropdown-select-helper"
				value={props.currentValue ? props.currentValue : field}
				onChange={handleChange}
				disabled={disabled}
				defaultValue={props.values[0]}
			>
				{props.values.map((currentValue) => {
					return <MenuItem value={currentValue}>{currentValue}</MenuItem>
				})}
			</Select>
			<FormHelperText>{props.helperText}</FormHelperText>
		</FormControl>
	)
}
